import React, { FC } from 'react'
import { SupportedCoins } from '@lib/web3/types/SupportedCoins'
import { useUI } from '@components/ui'
import { CryptoIcon } from '../CryptoIcon/CryptoIcon'

export interface CurrencySelectButtonProps {
  selectedCoin: SupportedCoins
}

export const CurrencySelectButton: FC<CurrencySelectButtonProps> = ({
  selectedCoin,
}: CurrencySelectButtonProps) => {
  const { toggleSidebar, setSidebarView } = useUI()

  return (
    <button
      className="flex items-center w-fit border-0 bg-transparent"
      onClick={() => {
        setSidebarView('CRYPTOCURRENCY_VIEW')
        toggleSidebar()
      }}
    >
      <span className="hidden lg:block font-bold mr-4">MY CURRENCY : </span>
      <CryptoIcon height="16px" width="16px" coin={selectedCoin} />
      <span className="ml-1 mr-1">{selectedCoin}</span>
      {'>'}
    </button>
  )
}
